import { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, Navigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { NumericFormat } from "react-number-format";
import { API_ENDPOINTS, API_BASE_URL } from "../../../js/api.js";
import {
  FaEdit,
  FaTrash,
  FaCalendarAlt,
  FaFilePdf,
  FaEye,
  FaCoins,
  FaSave,
  FaCheckCircle,
  FaClipboardCheck,
  FaCheck,
  FaArrowLeft,
  FaTimes,
} from "react-icons/fa";
import ToastContainer from "../../components/Toast/ToastContainer.js";
import useToast from "../../hooks/useToast.js";
import useConfirm from "../../hooks/useConfirm.js";
import "./style.css";

const verificarPermissao = () => {
  const token = localStorage.getItem("token");
  if (!token) return false;
  try {
    const decoded = jwtDecode(token);
    return decoded.tipo === "usuario_ciee";
  } catch {
    return false;
  }
};

const TcaConfiguracoes = () => {
  const navigate = useNavigate();
  const {
    toasts,
    removeToast,
    success: toastSuccess,
    error: toastError,
  } = useToast();
  const { confirm, confirmDialog } = useConfirm();
  const [abaAtiva, setAbaAtiva] = useState("datas");
  const [datas, setDatas] = useState([]);
  const [loadingDatas, setLoadingDatas] = useState(false);
  const [modalDataAberto, setModalDataAberto] = useState(false);
  const [editandoData, setEditandoData] = useState(null);
  const [novaData, setNovaData] = useState("");
  const [erroData, setErroData] = useState("");
  const [cursos, setCursos] = useState([]);
  const [loadingCursos, setLoadingCursos] = useState(false);
  const [modalCursoAberto, setModalCursoAberto] = useState(false);
  const [editandoCurso, setEditandoCurso] = useState(null);
  const [formCurso, setFormCurso] = useState({
    curso: "",
    carga_horaria: "",
    carga_horaria_total: "",
    modalidade: "Presencial",
    tipo_classificacao: "ARCO",
    cbos: [],
    municipios: [],
  });
  const [erroCurso, setErroCurso] = useState("");
  const [modalValidacaoAberto, setModalValidacaoAberto] = useState(false);
  const [editandoValidacao, setEditandoValidacao] = useState(null);
  const [validacoes, setValidacoes] = useState([]);
  const [loadingValidacoes, setLoadingValidacoes] = useState(false);
  const [formValidacao, setFormValidacao] = useState({
    tipo: "aprovacao",
    descricao: "",
    ativo: true,
  });
  const [erroValidacao, setErroValidacao] = useState("");
  const [horariosTeoricos, setHorariosTeoricos] = useState([]);
  const [loadingHorariosTeoricos, setLoadingHorariosTeoricos] = useState(false);
  const [modalHorarioTeoricoAberto, setModalHorarioTeoricoAberto] =
    useState(false);
  const [editandoHorarioTeorico, setEditandoHorarioTeorico] = useState(null);
  const [formHorarioTeorico, setFormHorarioTeorico] = useState({
    horario_inicio: "",
    horario_fim: "",
    municipios: [],
  });
  const [erroHorarioTeorico, setErroHorarioTeorico] = useState("");
  const [salarioMinimo, setSalarioMinimo] = useState(1621.0);
  const [ultimoSalarioSalvo, setUltimoSalarioSalvo] = useState(null);
  const [loadingSalario, setLoadingSalario] = useState(false);
  const [erroSalario, setErroSalario] = useState("");

  const formatarMoedaBR = (valor) => {
    if (valor === null || valor === undefined || valor === "") return "";
    const numero = Number(valor);
    if (isNaN(numero)) return "";
    return numero.toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const parseMoedaBR = (valor) => {
    if (valor === null || valor === undefined) return null;
    if (typeof valor === "number") return valor;
    if (typeof valor !== "string") return null;
    const limpo = valor
      .replace(/R\$\s?/gi, "")
      .replace(/\s/g, "")
      .replace(/\./g, "")
      .replace(",", ".")
      .trim();
    if (limpo === "") return null;
    const n = Number(limpo);
    return isNaN(n) ? null : n;
  };

  const handleSalarioChange = (e) => {
    const raw = e.target.value.replace(/\D/g, "");
    if (raw === "") {
      setSalarioMinimo("");
      return;
    }
    const numero = (Number(raw) / 100).toFixed(2);
    setSalarioMinimo(formatarMoedaBR(numero));
  };

  const [calendarios, setCalendarios] = useState([]);
  const [loadingCalendarios, setLoadingCalendarios] = useState(false);
  const [modalCalendarioAberto, setModalCalendarioAberto] = useState(false);
  const [editandoCalendario, setEditandoCalendario] = useState(null);
  const [formCalendario, setFormCalendario] = useState({
    data_vigencia: "",
    municipio: "",
  });
  const [arquivoCalendario, setArquivoCalendario] = useState(null);
  const [erroCalendario, setErroCalendario] = useState("");
  const [atividades, setAtividades] = useState([]);
  const [loadingAtividades, setLoadingAtividades] = useState(false);
  const [modalAtividadeAberto, setModalAtividadeAberto] = useState(false);
  const [editandoAtividade, setEditandoAtividade] = useState(null);
  const [formAtividade, setFormAtividade] = useState({
    descricao: "",
    carga_horaria: "",
  });
  const [erroAtividade, setErroAtividade] = useState("");
  const [municipiosMG, setMunicipiosMG] = useState([]);
  const [loadingMunicipios, setLoadingMunicipios] = useState(false);
  const token = localStorage.getItem("token");
  const authHeader = { Authorization: `Bearer ${token}` };

  useEffect(() => {
    carregarDatas();
    carregarCursos();
    carregarAtividades();
    carregarCalendarios();
    carregarSalarioMinimo();
    carregarValidacoes();
    carregarHorariosTeoricos();

    setLoadingMunicipios(true);
    axios
      .get(`${API_BASE_URL}/cidades/mg`, { headers: authHeader })
      .then((resp) => {
        const payload = resp?.data;
        console.info(
          `[TcaConfiguracoes] /cidades/mg respondeu com ${Array.isArray(payload) ? payload.length : "?"} itens`,
          payload,
        );
        let lista = [];
        if (Array.isArray(payload)) {
          lista = payload
            .map((c) => {
              if (typeof c === "string") return c;
              if (c && typeof c === "object")
                return c.cidade || c.nome || c.name || c.municipio || null;
              return null;
            })
            .filter(Boolean);
        }
        lista.sort((a, b) => a.localeCompare(b, "pt-BR"));
        setMunicipiosMG(lista);
      })
      .catch((err) => {
        console.error(
          "[TcaConfiguracoes] Erro ao carregar municípios de MG:",
          err.response?.status,
          err.response?.data || err.message,
        );
      })
      .finally(() => setLoadingMunicipios(false));
  }, []);

  const carregarValidacoes = async () => {
    setLoadingValidacoes(true);
    try {
      const resp = await axios.get(
        `${API_BASE_URL}/tca-configuracoes/validacoes`,
        { headers: authHeader },
      );
      setValidacoes(resp.data || []);
    } catch (err) {
      console.error("Erro ao carregar validações:", err);
    } finally {
      setLoadingValidacoes(false);
    }
  };

  const abrirModalValidacao = (validacao = null) => {
    setEditandoValidacao(validacao);
    setFormValidacao(
      validacao
        ? {
            tipo: validacao.valorObj?.tipo || "aprovacao",
            descricao: validacao.valorObj?.descricao || "",
            ativo:
              validacao.valorObj?.ativo !== undefined
                ? validacao.valorObj.ativo
                : true,
          }
        : { tipo: "aprovacao", descricao: "", ativo: true },
    );
    setErroValidacao("");
    setModalValidacaoAberto(true);
  };

  const salvarValidacao = async () => {
    setErroValidacao("");
    if (!formValidacao.tipo || !String(formValidacao.descricao).trim()) {
      setErroValidacao("Selecione o tipo e preencha a descrição.");
      return;
    }
    try {
      if (editandoValidacao) {
        await axios.put(
          `${API_BASE_URL}/tca-configuracoes/validacoes/${editandoValidacao.id}`,
          formValidacao,
          { headers: authHeader },
        );
      } else {
        await axios.post(
          `${API_BASE_URL}/tca-configuracoes/validacoes`,
          formValidacao,
          { headers: authHeader },
        );
      }
      setModalValidacaoAberto(false);
      carregarValidacoes();
      toastSuccess("Validação salva com sucesso!");
    } catch (err) {
      setErroValidacao(err.response?.data?.erro || "Erro ao salvar validação.");
    }
  };

  const excluirValidacao = async (id) => {
    const ok = await confirm({
      title: "Excluir validação",
      message: "Excluir esta validação?\nEsta ação não pode ser desfeita.",
      confirmText: "Sim, excluir",
      cancelText: "Cancelar",
      variant: "danger",
    });
    if (!ok) return;
    try {
      await axios.delete(`${API_BASE_URL}/tca-configuracoes/validacoes/${id}`, {
        headers: authHeader,
      });
      carregarValidacoes();
      toastSuccess("Validação excluída com sucesso!");
    } catch (err) {
      toastError(err.response?.data?.erro || "Erro ao excluir validação.");
    }
  };

  const toggleValidacaoAtivo = async (validacao) => {
    try {
      await axios.put(
        `${API_BASE_URL}/tca-configuracoes/validacoes/${validacao.id}`,
        {
          ...validacao.valorObj,
          ativo: !validacao.valorObj.ativo,
        },
        { headers: authHeader },
      );
      carregarValidacoes();
    } catch (err) {
      toastError(err.response?.data?.erro || "Erro ao atualizar validação.");
    }
  };

  const carregarDatas = async () => {
    setLoadingDatas(true);
    try {
      const resp = await axios.get(
        `${API_BASE_URL}/tca-configuracoes/datas-vigencia`,
        { headers: authHeader },
      );
      const dadosOrdenados = (resp.data || []).slice().sort((a, b) => {
        const dataA = new Date(a.valorObj.data + "T00:00:00");
        const dataB = new Date(b.valorObj.data + "T00:00:00");
        return dataA - dataB;
      });
      setDatas(dadosOrdenados);
    } catch (err) {
      console.error("Erro ao carregar datas:", err);
    } finally {
      setLoadingDatas(false);
    }
  };

  const carregarSalarioMinimo = async () => {
    setLoadingSalario(true);
    setErroSalario("");
    try {
      const resp = await axios.get(
        `${API_BASE_URL}/tca-configuracoes/salario-minimo`,
        { headers: authHeader },
      );

      console.log("[DEBUG] Resposta GET /salario-minimo:", resp.data);

      let valorEncontrado = null;
      const data = resp.data;

      if (data && data.vigente && data.vigente.valor !== undefined) {
        valorEncontrado = data.vigente.valor;
      } else if (Array.isArray(data) && data.length > 0) {
        valorEncontrado = data[data.length - 1].valor;
      } else if (data && data.valor !== undefined) {
        valorEncontrado = data.valor;
      } else if (data && Array.isArray(data.data) && data.data.length > 0) {
        valorEncontrado = data.data[data.data.length - 1].valor;
      } else if (data && data.data && data.data.valor !== undefined) {
        valorEncontrado = data.data.valor;
      }

      if (valorEncontrado !== null && valorEncontrado !== undefined) {
        let valorNumerico = null;
        if (typeof valorEncontrado === "number") {
          valorNumerico = valorEncontrado;
        } else if (typeof valorEncontrado === "string") {
          if (/^\d+\.\d{2}$/.test(valorEncontrado)) {
            valorNumerico = parseFloat(valorEncontrado);
          } else {
            valorNumerico = parseMoedaBR(valorEncontrado);
          }
        }

        if (valorNumerico !== null) {
          setSalarioMinimo(formatarMoedaBR(valorNumerico));
          setUltimoSalarioSalvo(valorNumerico);
        }
      }
    } catch (err) {
      console.error("Erro ao carregar salário mínimo:", err);
    } finally {
      setLoadingSalario(false);
    }
  };

  const salvarSalarioMinimo = async () => {
    setErroSalario("");

    if (loadingSalario) return;

    const valorNumerico = parseMoedaBR(salarioMinimo);
    if (valorNumerico === null || valorNumerico <= 0) {
      setErroSalario("Por favor, insira um valor válido maior que zero.");
      return;
    }

    setLoadingSalario(true);
    try {
      const resp = await axios.post(
        `${API_BASE_URL}/tca-configuracoes/salario-minimo`,
        { valor: valorNumerico },
        { headers: authHeader },
      );
      setUltimoSalarioSalvo(valorNumerico);
      setSalarioMinimo(formatarMoedaBR(valorNumerico));
      toastSuccess("Salário mínimo atualizado com sucesso!");
      if (typeof window !== "undefined" && window.console) {
        console.info("[salvarSalarioMinimo] OK", resp.status, resp.data);
      }
    } catch (err) {
      const status = err.response?.status;
      const erroBackend =
        err.response?.data?.erro ||
        err.response?.data?.message ||
        err.response?.data?.error;
      let mensagem = erroBackend || "Erro ao salvar salário mínimo.";
      if (status === 404) {
        mensagem =
          "Endpoint /tca-configuracoes/salario-minimo não encontrado no backend (404). Verifique se a rota POST foi implantada.";
      } else if (status === 405) {
        mensagem =
          "O backend não aceita POST nesse endpoint (405). Pode ser PUT, PATCH ou apenas GET.";
      } else if (status) {
        mensagem = `[${status}] ${mensagem}`;
      }
      if (typeof window !== "undefined" && window.console) {
        console.error("[salvarSalarioMinimo] Falhou:", {
          status,
          erroBackend,
          data: err.response?.data,
        });
      }
      setErroSalario(mensagem);
    } finally {
      setLoadingSalario(false);
    }
  };

  const carregarCursos = async () => {
    setLoadingCursos(true);
    try {
      const resp = await axios.get(`${API_BASE_URL}/tca-configuracoes/cursos`, {
        headers: authHeader,
      });
      setCursos(resp.data || []);
    } catch (err) {
      console.error("Erro ao carregar cursos:", err);
    } finally {
      setLoadingCursos(false);
    }
  };

  const carregarCalendarios = async () => {
    setLoadingCalendarios(true);
    try {
      const resp = await axios.get(
        `${API_BASE_URL}/tca-configuracoes/calendarios`,
        {
          headers: authHeader,
        },
      );
      setCalendarios(resp.data || []);
    } catch (err) {
      console.error("Erro ao carregar calendários:", err);
    } finally {
      setLoadingCalendarios(false);
    }
  };

  const abrirModalCalendario = (c = null) => {
    setEditandoCalendario(c);
    setFormCalendario(
      c
        ? { data_vigencia: c.data_vigencia, municipio: c.municipio }
        : { data_vigencia: "", municipio: "" },
    );
    setArquivoCalendario(null);
    setErroCalendario("");
    setModalCalendarioAberto(true);
  };

  const salvarCalendario = async () => {
    setErroCalendario("");
    if (
      !formCalendario.data_vigencia ||
      !String(formCalendario.municipio).trim()
    ) {
      setErroCalendario("Preencha data de vigência e município.");
      return;
    }
    if (!editandoCalendario && !arquivoCalendario) {
      setErroCalendario("Selecione um arquivo PDF.");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("data_vigencia", formCalendario.data_vigencia);
      formData.append("municipio", formCalendario.municipio);
      if (arquivoCalendario) {
        formData.append("arquivo", arquivoCalendario);
      }

      if (editandoCalendario) {
        setErroCalendario(
          "Edição não disponível. Exclua e cadastre novamente.",
        );
        return;
      } else {
        await axios.post(
          `${API_BASE_URL}/tca-configuracoes/calendarios`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "multipart/form-data",
            },
          },
        );
      }
      setModalCalendarioAberto(false);
      carregarCalendarios();
    } catch (err) {
      setErroCalendario(
        err.response?.data?.erro || "Erro ao salvar calendário.",
      );
    }
  };

  const excluirCalendario = async (id) => {
    try {
      await axios.delete(
        `${API_BASE_URL}/tca-configuracoes/calendarios/${id}`,
        { headers: authHeader },
      );
      carregarCalendarios();
    } catch (err) {
      toastError(err.response?.data?.erro || "Erro ao excluir.");
    }
  };

  const carregarAtividades = async () => {
    setLoadingAtividades(true);
    try {
      const resp = await axios.get(
        `${API_BASE_URL}/tca-configuracoes/atividades`,
        { headers: authHeader },
      );
      setAtividades(resp.data || []);
    } catch (err) {
      console.error("Erro ao carregar atividades:", err);
    } finally {
      setLoadingAtividades(false);
    }
  };

  const salvarAtividade = async () => {
    setErroAtividade("");
    if (!formAtividade.curso_id || !String(formAtividade.atividade).trim()) {
      setErroAtividade("Selecione um curso e informe a atividade.");
      return;
    }
    try {
      await axios.post(
        `${API_BASE_URL}/tca-configuracoes/atividades`,
        formAtividade,
        { headers: authHeader },
      );
      setModalAtividadeAberto(false);
      carregarAtividades();
    } catch (err) {
      setErroAtividade(err.response?.data?.erro || "Erro ao salvar atividade.");
    }
  };

  const abrirModalAtividade = (atividade = null) => {
    setEditandoAtividade(atividade);
    setFormAtividade(
      atividade
        ? {
            curso_id: atividade.curso_id || "",
            atividade: atividade.atividade || "",
          }
        : { curso_id: "", atividade: "" },
    );
    setErroAtividade("");
    setModalAtividadeAberto(true);
  };

  const excluirAtividade = async (id) => {
    if (!window.confirm("Excluir esta atividade?")) return;
    try {
      await axios.delete(`${API_BASE_URL}/tca-configuracoes/atividades/${id}`, {
        headers: authHeader,
      });
      carregarAtividades();
    } catch (err) {
      toastError(err.response?.data?.erro || "Erro ao excluir atividade.");
    }
  };

  const abrirModalData = (data = null) => {
    setEditandoData(data);
    setNovaData(data ? data.valorObj.data : "");
    setErroData("");
    setModalDataAberto(true);
  };

  const salvarData = async () => {
    setErroData("");
    if (!novaData) {
      setErroData("Selecione uma data.");
      return;
    }
    try {
      if (editandoData) {
        await axios.put(
          `${API_BASE_URL}/tca-configuracoes/datas-vigencia/${editandoData.id}`,
          { data: novaData },
          { headers: authHeader },
        );
      } else {
        await axios.post(
          `${API_BASE_URL}/tca-configuracoes/datas-vigencia`,
          { data: novaData },
          { headers: authHeader },
        );
      }
      setModalDataAberto(false);
      carregarDatas();
    } catch (err) {
      setErroData(err.response?.data?.erro || "Erro ao salvar data.");
    }
  };

  const excluirData = async (id) => {
    if (!window.confirm("Excluir esta data de vigência?")) return;
    try {
      await axios.delete(
        `${API_BASE_URL}/tca-configuracoes/datas-vigencia/${id}`,
        { headers: authHeader },
      );
      carregarDatas();
    } catch (err) {
      alert(err.response?.data?.erro || "Erro ao excluir.");
    }
  };

  const abrirModalCurso = (curso = null) => {
    setEditandoCurso(curso);
    setFormCurso(
      curso
        ? {
            ...curso.valorObj,
            tipo_classificacao: curso.valorObj?.tipo_classificacao || "ARCO",
            cbos: Array.isArray(curso.valorObj?.cbos)
              ? curso.valorObj.cbos
              : curso.valorObj?.cbo
                ? [curso.valorObj.cbo]
                : [],
          }
        : {
            curso: "",
            carga_horaria: "",
            carga_horaria_total: "",
            modalidade: "Presencial",
            tipo_classificacao: "ARCO",
            cbos: [],
            municipios: [],
          },
    );
    setErroCurso("");
    setModalCursoAberto(true);
  };

  const adicionarCbo = () => {
    setFormCurso((prev) => ({
      ...prev,
      cbos: [...(prev.cbos || []), ""],
    }));
  };

  const atualizarCbo = (index, valor) => {
    setFormCurso((prev) => {
      const novaLista = [...(prev.cbos || [])];
      novaLista[index] = valor;
      return { ...prev, cbos: novaLista };
    });
  };

  const removerCbo = (index) => {
    setFormCurso((prev) => {
      const novaLista = [...(prev.cbos || [])];
      novaLista.splice(index, 1);
      return { ...prev, cbos: novaLista };
    });
  };

  const handleTipoClassificacaoChange = (tipo) => {
    setFormCurso((prev) => {
      const novoForm = { ...prev, tipo_classificacao: tipo };
      // Ao trocar de tipo, reseta a lista de CBOs para evitar mistura de regras
      if (tipo === "CBO" && (prev.cbos || []).length > 1) {
        novoForm.cbos = prev.cbos.slice(0, 1);
      }
      return novoForm;
    });
  };

  const salvarCurso = async () => {
    setErroCurso("");
    if (
      !formCurso.curso ||
      !formCurso.carga_horaria ||
      !formCurso.modalidade ||
      formCurso.municipios.length === 0
    ) {
      setErroCurso(
        "Preencha todos os campos e selecione pelo menos 1 município.",
      );
      return;
    }

    // Validação da regra CBO / ARCO
    const cbosLimpos = (formCurso.cbos || [])
      .map((c) => String(c).trim())
      .filter(Boolean);

    if (!formCurso.tipo_classificacao) {
      setErroCurso("Selecione o tipo de classificação do curso (ARCO ou CBO).");
      return;
    }
    if (formCurso.tipo_classificacao === "CBO" && cbosLimpos.length !== 1) {
      setErroCurso("Para CBO, informe exatamente 1 (uma) CBO vinculada.");
      return;
    }
    if (formCurso.tipo_classificacao === "ARCO" && cbosLimpos.length === 0) {
      setErroCurso("Para ARCO, cadastre pelo menos 1 CBO vinculada.");
      return;
    }

    const payload = {
      ...formCurso,
      cbos: cbosLimpos,
      // Mantém compatibilidade com backends que esperam "cbo" único
      cbo: formCurso.tipo_classificacao === "CBO" ? cbosLimpos[0] : undefined,
    };

    try {
      if (editandoCurso) {
        await axios.put(
          `${API_BASE_URL}/tca-configuracoes/cursos/${editandoCurso.id}`,
          payload,
          { headers: authHeader },
        );
      } else {
        await axios.post(`${API_BASE_URL}/tca-configuracoes/cursos`, payload, {
          headers: authHeader,
        });
      }
      setModalCursoAberto(false);
      carregarCursos();
    } catch (err) {
      setErroCurso(err.response?.data?.erro || "Erro ao salvar curso.");
    }
  };

  const excluirCurso = async (id) => {
    if (!window.confirm("Excluir este curso?")) return;
    try {
      await axios.delete(`${API_BASE_URL}/tca-configuracoes/cursos/${id}`, {
        headers: authHeader,
      });
      carregarCursos();
    } catch (err) {
      alert(err.response?.data?.erro || "Erro ao excluir.");
    }
  };

  const toggleMunicipio = (m) => {
    setFormCurso((prev) => ({
      ...prev,
      municipios: prev.municipios.includes(m)
        ? prev.municipios.filter((x) => x !== m)
        : [...prev.municipios, m],
    }));
  };

  const carregarHorariosTeoricos = async () => {
    setLoadingHorariosTeoricos(true);
    try {
      const resp = await axios.get(
        `${API_BASE_URL}/tca-configuracoes/horarios-teoricos`,
        { headers: authHeader },
      );
      setHorariosTeoricos(resp.data || []);
    } catch (err) {
      console.error("Erro ao carregar horários teóricos:", err);
    } finally {
      setLoadingHorariosTeoricos(false);
    }
  };

  const abrirModalHorarioTeorico = (horario = null) => {
    setEditandoHorarioTeorico(horario);
    setFormHorarioTeorico(
      horario
        ? {
            horario_inicio: horario.horario_inicio || "",
            horario_fim: horario.horario_fim || "",
            municipios: Array.isArray(horario.municipios)
              ? horario.municipios
              : [],
          }
        : {
            horario_inicio: "",
            horario_fim: "",
            municipios: [],
          },
    );
    setErroHorarioTeorico("");
    setModalHorarioTeoricoAberto(true);
  };

  const salvarHorarioTeorico = async () => {
    setErroHorarioTeorico("");
    if (
      !formHorarioTeorico.horario_inicio ||
      !formHorarioTeorico.horario_fim ||
      !formHorarioTeorico.municipios ||
      formHorarioTeorico.municipios.length === 0
    ) {
      setErroHorarioTeorico(
        "Preencha horário de início, término e selecione pelo menos 1 município.",
      );
      return;
    }
    try {
      if (editandoHorarioTeorico) {
        await axios.put(
          `${API_BASE_URL}/tca-configuracoes/horarios-teoricos/${editandoHorarioTeorico.id}`,
          formHorarioTeorico,
          { headers: authHeader },
        );
      } else {
        await axios.post(
          `${API_BASE_URL}/tca-configuracoes/horarios-teoricos`,
          formHorarioTeorico,
          { headers: authHeader },
        );
      }
      setModalHorarioTeoricoAberto(false);
      carregarHorariosTeoricos();
    } catch (err) {
      setErroHorarioTeorico(
        err.response?.data?.erro || "Erro ao salvar horário teórico.",
      );
    }
  };

  const excluirHorarioTeorico = async (id) => {
    if (!window.confirm("Excluir este horário teórico?")) return;
    try {
      await axios.delete(
        `${API_BASE_URL}/tca-configuracoes/horarios-teoricos/${id}`,
        { headers: authHeader },
      );
      carregarHorariosTeoricos();
    } catch (err) {
      alert(err.response?.data?.erro || "Erro ao excluir.");
    }
  };

  const toggleMunicipioHorarioTeorico = (m) => {
    setFormHorarioTeorico((prev) => ({
      ...prev,
      municipios: (prev.municipios || []).includes(m)
        ? prev.municipios.filter((x) => x !== m)
        : [...(prev.municipios || []), m],
    }));
  };

  if (!verificarPermissao()) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div className="cfg-container">
      <header className="cfg-header">
        <h1>Configurações — Autorizações de Aprendizagem</h1>
        <button
          className="cfg-btn cfg-btn-secondary"
          onClick={() => navigate("/dashboard")}
        >
          <FaArrowLeft /> Voltar
        </button>
      </header>
      <div className="cfg-tabs">
        <button
          className={`cfg-tab ${abaAtiva === "datas" ? "cfg-tab-ativa" : ""}`}
          onClick={() => setAbaAtiva("datas")}
        >
          Datas de Início de Vigência
        </button>
        <button
          className={`cfg-tab ${abaAtiva === "cursos" ? "cfg-tab-ativa" : ""}`}
          onClick={() => setAbaAtiva("cursos")}
        >
          Cursos
        </button>
        <button
          className={`cfg-tab ${abaAtiva === "atividades" ? "cfg-tab-ativa" : ""}`}
          onClick={() => setAbaAtiva("atividades")}
        >
          Atividades
        </button>
        <button
          className={`cfg-tab ${abaAtiva === "salario_minimo" ? "cfg-tab-ativa" : ""}`}
          onClick={() => setAbaAtiva("salario_minimo")}
        >
          Salário Mínimo
        </button>
        <button
          className={`cfg-tab ${abaAtiva === "calendarios" ? "cfg-tab-ativa" : ""}`}
          onClick={() => setAbaAtiva("calendarios")}
        >
          Calendários
        </button>
        <button
          className={`cfg-tab ${abaAtiva === "horarios_teoricos" ? "cfg-tab-ativa" : ""}`}
          onClick={() => setAbaAtiva("horarios_teoricos")}
        >
          Horários da Aprendizagem Teórica
        </button>
      </div>
      {abaAtiva === "datas" && (
        <section className="cfg-section">
          <div className="cfg-section-header">
            <h2>Datas de Início de Vigência</h2>
            <button
              className="cfg-btn cfg-btn-primary"
              onClick={() => abrirModalData()}
            >
              + Nova Data
            </button>
          </div>
          {loadingDatas ? (
            <p>Carregando...</p>
          ) : datas.length === 0 ? (
            <p className="cfg-empty">Nenhuma data cadastrada.</p>
          ) : (
            <table className="cfg-table">
              <thead>
                <tr>
                  <th>Data</th>
                  <th>Situação</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                {datas.map((d) => {
                  const isFutura =
                    d.valorObj?.data >= new Date().toISOString().split("T")[0];
                  return (
                    <tr key={d.id}>
                      <td>
                        {new Date(
                          d.valorObj.data + "T00:00:00",
                        ).toLocaleDateString("pt-BR")}
                      </td>
                      <td>
                        <span
                          className={`cfg-badge ${isFutura ? "cfg-badge-futura" : "cfg-badge-passada"}`}
                        >
                          {isFutura ? "Futura" : "Passada"}
                        </span>
                      </td>
                      <td>
                        <button
                          className="cfg-btn-icon"
                          onClick={() => abrirModalData(d)}
                          title="Editar"
                        >
                          <FaEdit />
                        </button>
                        <button
                          className="cfg-btn-icon"
                          onClick={() => excluirData(d.id)}
                          title="Excluir"
                        >
                          <FaTrash />
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </section>
      )}

      {abaAtiva === "cursos" && (
        <section className="cfg-section">
          <div className="cfg-section-header">
            <h2>Cursos</h2>
            <button
              className="cfg-btn cfg-btn-primary"
              onClick={() => abrirModalCurso()}
            >
              + Novo Curso
            </button>
          </div>
          {loadingCursos ? (
            <p>Carregando...</p>
          ) : cursos.length === 0 ? (
            <p className="cfg-empty">Nenhum curso cadastrado.</p>
          ) : (
            <table className="cfg-table">
              <thead>
                <tr>
                  <th>Curso</th>
                  <th>Carga Horária</th>
                  <th>Modalidade</th>
                  <th>Municípios</th>
                  <th>Tipo de Classificação</th>
                  <th>Ações</th>
                </tr>
              </thead>

              <tbody>
                {cursos.map((c) => {
                  const tipo = c.valorObj?.tipo_classificacao;

                  const cbos = Array.isArray(c.valorObj?.cbos)
                    ? c.valorObj.cbos
                    : c.valorObj?.cbo
                      ? [c.valorObj.cbo]
                      : [];

                  return (
                    <tr key={c.id}>
                      <td>{c.valorObj.curso}</td>
                      <td>{c.valorObj.carga_horaria}</td>
                      <td>{c.valorObj.modalidade}</td>
                      <td>{c.valorObj.municipios.join(", ")}</td>

                      <td>
                        {tipo && (
                          <span
                            className={`cfg-badge ${
                              tipo === "ARCO"
                                ? "cfg-badge-futura"
                                : "cfg-badge-passada"
                            }`}
                          >
                            {tipo}
                          </span>
                        )}
                      </td>
                      <td>
                        <button
                          className="cfg-btn-icon"
                          onClick={() => abrirModalCurso(c)}
                          title="Editar"
                        >
                          <FaEdit />
                        </button>
                        <button
                          className="cfg-btn-icon"
                          onClick={() => excluirCurso(c.id)}
                          title="Excluir"
                        >
                          <FaTrash />
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </section>
      )}

      {abaAtiva === "atividades" && (
        <section className="cfg-section">
          <div className="cfg-section-header">
            <h2>Atividades</h2>
            <button
              className="cfg-btn cfg-btn-primary"
              onClick={() => abrirModalAtividade()}
            >
              + Nova Atividade
            </button>
          </div>
          {loadingAtividades ? (
            <p>Carregando...</p>
          ) : atividades.length === 0 ? (
            <p className="cfg-empty">Nenhuma atividade cadastrada.</p>
          ) : (
            <table className="cfg-table">
              <thead>
                <tr>
                  <th>Curso</th>
                  <th>Atividade</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                {atividades.map((a) => {
                  const curso = cursos.find((c) => c.id === a.curso_id);
                  return (
                    <tr key={a.id}>
                      <td>
                        {curso
                          ? curso.valorObj?.curso
                          : a.curso_id
                            ? `(ID ${a.curso_id})`
                            : "-"}
                      </td>
                      <td>{a.atividade || "-"}</td>
                      <td>
                        <button
                          className="cfg-btn-icon"
                          onClick={() => abrirModalAtividade(a)}
                          title="Editar"
                        >
                          <FaEdit />
                        </button>
                        <button
                          className="cfg-btn-icon"
                          onClick={() => excluirAtividade(a.id)}
                          title="Excluir"
                        >
                          <FaTrash />
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </section>
      )}

      {abaAtiva === "calendarios" && (
        <section className="cfg-section">
          <div className="cfg-section-header">
            <h2>
              <FaCalendarAlt
                style={{ marginRight: 8, verticalAlign: "middle" }}
              />
              Calendários
            </h2>
            <button
              className="cfg-btn cfg-btn-primary"
              onClick={() => abrirModalCalendario()}
            >
              + Novo Calendário
            </button>
          </div>
          {loadingCalendarios ? (
            <p>Carregando...</p>
          ) : calendarios.length === 0 ? (
            <p className="cfg-empty">Nenhum calendário cadastrado.</p>
          ) : (
            <table className="cfg-table">
              <thead>
                <tr>
                  <th>Data de Vigência</th>
                  <th>Município</th>
                  <th>Arquivo</th>
                  <th>Cadastrado em</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                {calendarios.map((c) => (
                  <tr key={c.id}>
                    <td>
                      {new Date(
                        c.data_vigencia + "T00:00:00",
                      ).toLocaleDateString("pt-BR")}
                    </td>
                    <td>{c.municipio}</td>
                    <td>
                      <FaFilePdf style={{ color: "#dc2626", marginRight: 6 }} />
                      {c.arquivo_nome_original}
                      <a
                        href={`${API_BASE_URL}${c.arquivo_path}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="cfg-btn-icon"
                        title="Visualizar PDF"
                        style={{ marginLeft: 8 }}
                      >
                        <FaEye />
                      </a>
                    </td>
                    <td>
                      {c.created_at
                        ? new Date(c.created_at).toLocaleString("pt-BR")
                        : "-"}
                    </td>
                    <td>
                      <button
                        className="cfg-btn-icon"
                        onClick={() => excluirCalendario(c.id)}
                        title="Excluir"
                      >
                        <FaTrash />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </section>
      )}

      {abaAtiva === "validacoes" && (
        <section className="cfg-section">
          <div className="cfg-section-header">
            <h2>
              <FaClipboardCheck
                style={{ marginRight: 8, verticalAlign: "middle" }}
              />
              Minhas Validações
            </h2>
            <button
              className="cfg-btn cfg-btn-primary"
              onClick={() => abrirModalValidacao()}
            >
              + Novos para Validação
            </button>
          </div>
          {loadingValidacoes ? (
            <p>Carregando...</p>
          ) : validacoes.length === 0 ? (
            <p className="cfg-empty">Nenhuma validação cadastrada.</p>
          ) : (
            <table className="cfg-table">
              <thead>
                <tr>
                  <th>Tipo</th>
                  <th>Descrição</th>
                  <th>Situação</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                {validacoes.map((v) => {
                  const tipoLabel =
                    v.valorObj?.tipo === "aprovacao"
                      ? "Aprovação"
                      : v.valorObj?.tipo === "rejeicao"
                        ? "Rejeição"
                        : v.valorObj?.tipo === "pendencia"
                          ? "Pendência"
                          : v.valorObj?.tipo || "-";
                  const ativo = v.valorObj?.ativo;
                  return (
                    <tr key={v.id}>
                      <td>{tipoLabel}</td>
                      <td>{v.valorObj?.descricao || "-"}</td>
                      <td>
                        <span
                          className={`cfg-badge ${ativo ? "cfg-badge-futura" : "cfg-badge-passada"}`}
                        >
                          {ativo ? "Ativa" : "Inativa"}
                        </span>
                      </td>
                      <td>
                        <button
                          className="cfg-btn-icon"
                          onClick={() => toggleValidacaoAtivo(v)}
                          title={ativo ? "Desativar" : "Ativar"}
                        >
                          {ativo ? <FaTimes /> : <FaCheck />}
                        </button>
                        <button
                          className="cfg-btn-icon"
                          onClick={() => abrirModalValidacao(v)}
                          title="Editar"
                        >
                          <FaEdit />
                        </button>
                        <button
                          className="cfg-btn-icon"
                          onClick={() => excluirValidacao(v.id)}
                          title="Excluir"
                        >
                          <FaTrash />
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </section>
      )}

      {abaAtiva === "salario_minimo" && (
        <section className="sal-section">
          <div className="sal-section-header">
            <div className="sal-header-titulo">
              <div className="sal-icon-box">
                <FaFilePdf size={22} />
              </div>
              <div>
                <h2 className="sal-titulo">Configuração de Salário Mínimo</h2>
                <p className="sal-subtitulo">
                  Defina o salário mínimo de referência usado para os cálculos e
                  validações.
                </p>
              </div>
            </div>
          </div>

          {loadingSalario && !ultimoSalarioSalvo ? (
            <div className="sal-loading">
              <div className="sal-loading-spinner" />
              <p className="sal-loading-text">Carregando salário mínimo...</p>
            </div>
          ) : (
            <div className="sal-grid">
              {/* Card de Configuração (esquerda) */}
              <div className="sal-card-config">
                <h3 className="sal-card-titulo">Atualizar Valor</h3>
                <div className="sal-form-group">
                  <label className="sal-label" htmlFor="salario-input">
                    Novo valor do salário mínimo (R$):
                  </label>
                  <input
                    id="salario-input"
                    type="text"
                    inputMode="decimal"
                    value={salarioMinimo}
                    onChange={handleSalarioChange}
                    className="sal-input"
                    placeholder="R$ 0,00"
                  />
                </div>
                {erroSalario && (
                  <div className="sal-erro">
                    <span className="sal-erro-icone">⚠️</span>
                    <span>{erroSalario}</span>
                  </div>
                )}
                <button
                  type="button"
                  className="sal-btn-salvar"
                  onClick={salvarSalarioMinimo}
                  disabled={loadingSalario}
                >
                  {loadingSalario ? (
                    "Salvando..."
                  ) : (
                    <>
                      <FaFilePdf size={16} /> Salvar Valor
                    </>
                  )}
                </button>
              </div>

              {/* Card de Status (direita) */}
              <div className="sal-card-status">
                <h3 className="sal-card-titulo">Valor Salvo no Sistema</h3>
                <div className="sal-status-item">
                  <div className="sal-status-icone">
                    <FaFilePdf size={22} />
                  </div>
                  <div>
                    <span className="sal-status-label">Valor Ativo</span>
                    <span className="sal-status-valor">
                      {ultimoSalarioSalvo !== null
                        ? formatarMoedaBR(ultimoSalarioSalvo)
                        : "—"}
                    </span>
                  </div>
                </div>
                <p className="sal-info">
                  Este valor é a base para o cálculo dos contratos de aprendizes
                  da CIEE/MG. A alteração deste salário mínimo impactará
                  imediatamente os novos cadastros de TCA.
                </p>

                <div className="info-container">
                  <p className="ponto-info">
                    Aprendiz - 4 horas diárias: 4 x valor do salário mínimo = R$
                    761,55
                  </p>
                  <p className="ponto-info">
                    Estagiário - 6 horas diárias: 6 x valor do salário mínimo =
                    R$ 1.142,33
                  </p>
                </div>
              </div>
            </div>
          )}
        </section>
      )}

      {modalDataAberto && (
        <div
          className="cfg-modal-overlay"
          onClick={() => setModalDataAberto(false)}
        >
          <div className="cfg-modal" onClick={(e) => e.stopPropagation()}>
            <h3>{editandoData ? "Editar Data" : "Nova Data de Vigência"}</h3>
            <label>Data de início:</label>
            <input
              type="date"
              value={novaData}
              onChange={(e) => setNovaData(e.target.value)}
              className="cfg-input"
            />
            {erroData && <p className="cfg-erro">{erroData}</p>}
            <div className="cfg-modal-actions">
              <button
                className="cfg-btn cfg-btn-secondary"
                onClick={() => setModalDataAberto(false)}
              >
                Cancelar
              </button>
              <button className="cfg-btn cfg-btn-primary" onClick={salvarData}>
                Salvar
              </button>
            </div>
          </div>
        </div>
      )}

      {abaAtiva === "horarios_teoricos" && (
        <section className="cfg-section">
          <div className="cfg-section-header">
            <h2>Horários da Aprendizagem Teórica</h2>
            <button
              className="cfg-btn cfg-btn-primary"
              onClick={() => abrirModalHorarioTeorico()}
            >
              + Novo Horário
            </button>
          </div>
          {loadingHorariosTeoricos ? (
            <p>Carregando...</p>
          ) : horariosTeoricos.length === 0 ? (
            <p className="cfg-empty">
              Nenhum horário teórico cadastrado. Clique em{" "}
              <strong>+ Novo Horário</strong> para começar.
            </p>
          ) : (
            <table className="cfg-table">
              <thead>
                <tr>
                  <th>Início</th>
                  <th>Término</th>
                  <th>Municípios</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                {horariosTeoricos.map((h) => (
                  <tr key={h.id}>
                    <td>{h.horario_inicio || "-"}</td>
                    <td>{h.horario_fim || "-"}</td>
                    <td>{(h.municipios || []).join(", ") || "-"}</td>
                    <td>
                      <button
                        className="cfg-btn-icon"
                        onClick={() => abrirModalHorarioTeorico(h)}
                        title="Editar"
                      >
                        <FaEdit />
                      </button>
                      <button
                        className="cfg-btn-icon"
                        onClick={() => excluirHorarioTeorico(h.id)}
                        title="Excluir"
                      >
                        <FaTrash />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </section>
      )}

      {modalHorarioTeoricoAberto && (
        <div
          className="cfg-modal-overlay"
          onClick={() => setModalHorarioTeoricoAberto(false)}
        >
          <div
            className="cfg-modal cfg-modal-lg"
            onClick={(e) => e.stopPropagation()}
          >
            <h3>
              {editandoHorarioTeorico
                ? "Editar Horário Teórico"
                : "Novo Horário Teórico"}
            </h3>
            <div className="tca-d-flex tca-gap-2">
              <div style={{ flex: 1 }}>
                <label>Horário de Início:</label>
                <input
                  type="time"
                  value={formHorarioTeorico.horario_inicio}
                  onChange={(e) =>
                    setFormHorarioTeorico({
                      ...formHorarioTeorico,
                      horario_inicio: e.target.value,
                    })
                  }
                  className="cfg-input"
                />
              </div>
              <div style={{ flex: 1 }}>
                <label>Horário de Término:</label>
                <input
                  type="time"
                  value={formHorarioTeorico.horario_fim}
                  onChange={(e) =>
                    setFormHorarioTeorico({
                      ...formHorarioTeorico,
                      horario_fim: e.target.value,
                    })
                  }
                  className="cfg-input"
                />
              </div>
            </div>
            <label>
              Municípios ({(formHorarioTeorico.municipios || []).length}{" "}
              selecionados):
            </label>
            {loadingMunicipios ? (
              <p style={{ fontSize: "0.85rem", color: "#666" }}>
                Carregando municípios de MG...
              </p>
            ) : municipiosMG.length === 0 ? (
              <p className="cfg-erro">
                ⚠️ Nenhum município carregado. Verifique o console do navegador
                (F12) — a rota <code>GET /cidades/mg</code> pode não existir no
                back-end.
              </p>
            ) : (
              <div className="cfg-municipios-grid">
                {municipiosMG.map((m) => (
                  <label key={m} className="cfg-checkbox-item">
                    <input
                      type="checkbox"
                      checked={(formHorarioTeorico.municipios || []).includes(
                        m,
                      )}
                      onChange={() => toggleMunicipioHorarioTeorico(m)}
                    />
                    {m}
                  </label>
                ))}
              </div>
            )}
            {erroHorarioTeorico && (
              <p className="cfg-erro">{erroHorarioTeorico}</p>
            )}
            <div className="cfg-modal-actions">
              <button
                className="cfg-btn cfg-btn-secondary"
                onClick={() => setModalHorarioTeoricoAberto(false)}
              >
                Cancelar
              </button>
              <button
                className="cfg-btn cfg-btn-primary"
                onClick={salvarHorarioTeorico}
              >
                Salvar
              </button>
            </div>
          </div>
        </div>
      )}
      {modalValidacaoAberto && (
        <div
          className="cfg-modal-overlay"
          onClick={() => setModalValidacaoAberto(false)}
        >
          <div className="cfg-modal" onClick={(e) => e.stopPropagation()}>
            <h3>Nova Validação</h3>
            <p>Em construção...</p>
            <div className="cfg-modal-actions">
              <button
                className="cfg-btn cfg-btn-secondary"
                onClick={() => setModalValidacaoAberto(false)}
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>
      )}

      {modalCursoAberto && (
        <div
          className="cfg-modal-overlay"
          onClick={() => setModalCursoAberto(false)}
        >
          <div
            className="cfg-modal cfg-modal-lg"
            onClick={(e) => e.stopPropagation()}
          >
            <h3>{editandoCurso ? "Editar Curso" : "Novo Curso"}</h3>
            <label>Curso:</label>
            <input
              type="text"
              value={formCurso.curso}
              onChange={(e) =>
                setFormCurso({ ...formCurso, curso: e.target.value })
              }
              className="cfg-input"
            />{" "}
            <label>Tipo de classificação do curso:</label>
            <div className="cfg-radio-group">
              <label>
                <input
                  type="radio"
                  name="tipo_classificacao"
                  value="ARCO"
                  checked={formCurso.tipo_classificacao === "ARCO"}
                  onChange={() => handleTipoClassificacaoChange("ARCO")}
                />
                ARCO
              </label>
              <label>
                <input
                  type="radio"
                  name="tipo_classificacao"
                  value="CBO"
                  checked={formCurso.tipo_classificacao === "CBO"}
                  onChange={() => handleTipoClassificacaoChange("CBO")}
                />
                CBO
              </label>
            </div>
            {formCurso.tipo_classificacao === "CBO" && (
              <>
                <label>CBO vinculada ao curso (1):</label>
                <input
                  type="text"
                  value={(formCurso.cbos && formCurso.cbos[0]) || ""}
                  onChange={(e) => {
                    const valor = e.target.value;
                    setFormCurso((prev) => ({
                      ...prev,
                      cbos: valor ? [valor] : [],
                    }));
                  }}
                  className="cfg-input"
                  placeholder="Ex: 4110-10 - Auxiliar administrativo"
                />
              </>
            )}
            {formCurso.tipo_classificacao === "ARCO" && (
              <>
                <label>
                  CBOs vinculadas ao curso ({(formCurso.cbos || []).length}):
                </label>
                {(formCurso.cbos || []).map((cbo, idx) => (
                  <div
                    key={`cbo-${idx}`}
                    style={{
                      display: "flex",
                      gap: 8,
                      alignItems: "center",
                      marginBottom: 6,
                    }}
                  >
                    <input
                      type="text"
                      value={cbo}
                      onChange={(e) => atualizarCbo(idx, e.target.value)}
                      className="cfg-input"
                      placeholder={`CBO ${idx + 1} - Ex: 4110-10`}
                      style={{ flex: 1 }}
                    />
                    <button
                      type="button"
                      className="cfg-btn cfg-btn-secondary"
                      onClick={() => removerCbo(idx)}
                      title="Remover CBO"
                      style={{ padding: "6px 10px" }}
                    >
                      <FaTimes />
                    </button>
                  </div>
                ))}
                <button
                  type="button"
                  className="cfg-btn cfg-btn-secondary"
                  onClick={adicionarCbo}
                  style={{ marginTop: 4, alignSelf: "flex-start" }}
                >
                  + Adicionar CBO
                </button>
              </>
            )}
            <label>Carga Horária diária:</label>
            <input
              type="text"
              value={formCurso.carga_horaria}
              onChange={(e) =>
                setFormCurso({ ...formCurso, carga_horaria: e.target.value })
              }
              className="cfg-input"
              placeholder="Ex: 4h "
            />
            <label>Carga Horária total:</label>
            <input
              type="text"
              value={formCurso.carga_horaria_total || ""}
              onChange={(e) =>
                setFormCurso({
                  ...formCurso,
                  carga_horaria_total: e.target.value,
                })
              }
              className="cfg-input"
              placeholder="Ex: 1.900h"
            />
            <label>Modalidade:</label>
            <div className="cfg-radio-group">
              <label>
                <input
                  type="radio"
                  name="modalidade"
                  value="Presencial"
                  checked={formCurso.modalidade === "Presencial"}
                  onChange={(e) =>
                    setFormCurso({ ...formCurso, modalidade: e.target.value })
                  }
                />
                Presencial
              </label>
              <label>
                <input
                  type="radio"
                  name="modalidade"
                  value="EAD"
                  checked={formCurso.modalidade === "EAD"}
                  onChange={(e) =>
                    setFormCurso({ ...formCurso, modalidade: e.target.value })
                  }
                />
                EAD
              </label>
            </div>
            <label>
              Municípios ({formCurso.municipios.length} selecionados):
            </label>
            {loadingMunicipios ? (
              <p style={{ fontSize: "0.85rem", color: "#666" }}>
                Carregando municípios de MG...
              </p>
            ) : municipiosMG.length === 0 ? (
              <p className="cfg-erro">
                ⚠️ Nenhum município carregado. Verifique o console do navegador
                (F12) — a rota <code>GET /cidades/mg</code> pode não existir no
                back-end.
              </p>
            ) : (
              <div className="cfg-municipios-grid">
                {municipiosMG.map((m) => (
                  <label key={m} className="cfg-checkbox-item">
                    <input
                      type="checkbox"
                      checked={formCurso.municipios.includes(m)}
                      onChange={() => toggleMunicipio(m)}
                    />
                    {m}
                  </label>
                ))}
              </div>
            )}
            {erroCurso && <p className="cfg-erro">{erroCurso}</p>}
            <div className="cfg-modal-actions">
              <button
                className="cfg-btn cfg-btn-secondary"
                onClick={() => setModalCursoAberto(false)}
              >
                Cancelar
              </button>
              <button className="cfg-btn cfg-btn-primary" onClick={salvarCurso}>
                Salvar
              </button>
            </div>
          </div>
        </div>
      )}

      {modalAtividadeAberto && (
        <div
          className="cfg-modal-overlay"
          onClick={() => setModalAtividadeAberto(false)}
        >
          <div className="cfg-modal" onClick={(e) => e.stopPropagation()}>
            <h3>{editandoAtividade ? "Editar Atividade" : "Nova Atividade"}</h3>
            <label>Curso:</label>
            <select
              value={formAtividade.curso_id}
              onChange={(e) =>
                setFormAtividade({ ...formAtividade, curso_id: e.target.value })
              }
              className="cfg-input"
            >
              <option value="">Selecione um curso</option>
              {cursos.map((c) => (
                <option key={c.id} value={c.id}>
                  {c.valorObj.curso}
                </option>
              ))}
            </select>
            <label>Atividade:</label>
            <input
              type="text"
              value={formAtividade.atividade}
              onChange={(e) =>
                setFormAtividade({
                  ...formAtividade,
                  atividade: e.target.value,
                })
              }
              className="cfg-input"
              placeholder="Ex: Auxiliar administrativo"
            />
            {erroAtividade && <p className="cfg-erro">{erroAtividade}</p>}
            <div className="cfg-modal-actions">
              <button
                className="cfg-btn cfg-btn-secondary"
                onClick={() => setModalAtividadeAberto(false)}
              >
                Cancelar
              </button>
              <button
                className="cfg-btn cfg-btn-primary"
                onClick={salvarAtividade}
              >
                Salvar
              </button>
            </div>
          </div>
        </div>
      )}

      {modalValidacaoAberto && (
        <div
          className="cfg-modal-overlay"
          onClick={() => setModalValidacaoAberto(false)}
        >
          <div className="cfg-modal" onClick={(e) => e.stopPropagation()}>
            <h3>
              <FaClipboardCheck
                style={{ marginRight: 8, verticalAlign: "middle" }}
              />
              {editandoValidacao ? "Editar Validação" : "Nova Validação"}
            </h3>
            <label>Tipo de Validação:</label>
            <select
              value={formValidacao.tipo}
              onChange={(e) =>
                setFormValidacao({ ...formValidacao, tipo: e.target.value })
              }
              className="cfg-input"
            >
              <option value="aprovacao">Aprovação</option>
              <option value="rejeicao">Rejeição</option>
              <option value="pendencia">Pendência</option>
            </select>
            <label>Descrição:</label>
            <textarea
              value={formValidacao.descricao}
              onChange={(e) =>
                setFormValidacao({
                  ...formValidacao,
                  descricao: e.target.value,
                })
              }
              className="cfg-input"
              rows={4}
              placeholder="Descreva a validação..."
              style={{ resize: "vertical", fontFamily: "inherit" }}
            />
            <label className="cfg-checkbox-item" style={{ marginTop: 12 }}>
              <input
                type="checkbox"
                checked={formValidacao.ativo}
                onChange={(e) =>
                  setFormValidacao({
                    ...formValidacao,
                    ativo: e.target.checked,
                  })
                }
              />
              Validação ativa
            </label>
            {erroValidacao && <p className="cfg-erro">{erroValidacao}</p>}
            <div className="cfg-modal-actions">
              <button
                className="cfg-btn cfg-btn-secondary"
                onClick={() => setModalValidacaoAberto(false)}
              >
                Cancelar
              </button>
              <button
                className="cfg-btn cfg-btn-primary"
                onClick={salvarValidacao}
              >
                Salvar
              </button>
            </div>
          </div>
        </div>
      )}

      {modalCalendarioAberto && (
        <div
          className="cfg-modal-overlay"
          onClick={() => setModalCalendarioAberto(false)}
        >
          <div className="cfg-modal" onClick={(e) => e.stopPropagation()}>
            <h3>
              <FaCalendarAlt
                style={{ marginRight: 8, verticalAlign: "middle" }}
              />
              Novo Calendário
            </h3>
            <label>Data de Início da Vigência:</label>
            <select
              value={formCalendario.data_vigencia}
              onChange={(e) =>
                setFormCalendario({
                  ...formCalendario,
                  data_vigencia: e.target.value,
                })
              }
              className="cfg-input"
            >
              <option value="">Selecione uma data cadastrada</option>
              {datas.map((d) => (
                <option key={d.id} value={d.valorObj.data}>
                  {new Date(d.valorObj.data + "T00:00:00").toLocaleDateString(
                    "pt-BR",
                  )}
                </option>
              ))}
            </select>
            <label>Município:</label>
            <input
              type="text"
              value={formCalendario.municipio}
              onChange={(e) =>
                setFormCalendario({
                  ...formCalendario,
                  municipio: e.target.value,
                })
              }
              className="cfg-input"
              placeholder="Ex: Belo Horizonte"
              list="lista-municipios-cal"
            />
            <datalist id="lista-municipios-cal">
              {municipiosMG.map((m) => (
                <option key={m} value={m} />
              ))}
            </datalist>
            <label>Arquivo PDF (máx 10MB):</label>
            <input
              type="file"
              accept="application/pdf"
              onChange={(e) =>
                setArquivoCalendario(e.target.files?.[0] || null)
              }
              className="cfg-input"
            />
            {arquivoCalendario && (
              <p style={{ fontSize: "0.85rem", color: "#666", marginTop: 4 }}>
                <FaFilePdf style={{ color: "#dc2626", marginRight: 4 }} />
                {arquivoCalendario.name} (
                {(arquivoCalendario.size / 1024 / 1024).toFixed(2)} MB)
              </p>
            )}
            {erroCalendario && <p className="cfg-erro">{erroCalendario}</p>}
            <div className="cfg-modal-actions">
              <button
                className="cfg-btn cfg-btn-secondary"
                onClick={() => setModalCalendarioAberto(false)}
              >
                Cancelar
              </button>
              <button
                className="cfg-btn cfg-btn-primary"
                onClick={salvarCalendario}
              >
                Salvar
              </button>
            </div>
          </div>
        </div>
      )}

      <ToastContainer toasts={toasts} onRemove={removeToast} />

      {confirmDialog}
    </div>
  );
};
export default TcaConfiguracoes;
